import { useLazyQuery } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { ContractLineGridFilterInput } from '@/graphql/contracts/_generated_/contracts';
import {
  GetPaginatedFilteredGridContractLines,
  GetPaginatedFilteredGridContractLinesVariables,
} from '@/graphql/contracts/_generated_/getPaginatedFilteredGridContractLines.query';
import GetPaginatedFilteredGridContractLinesQuery
  from '@/graphql/contracts/getPaginatedFilteredGridContractLines.query.gql';
import { notificationService } from '@/services/notification/notification.client';
import { PaginatedFilteredGridData } from '@/utils/data-helpers/PaginatedFilteredGridData';


export type PaginatedFilteredGridContractLines =
  PaginatedFilteredGridData<ContractLineGridFilterInput>;

export function useGetGridContractLines() {
  const [_getGridContractLines, { loading: getGridContractLinesLoading }] = useLazyQuery<
  GetPaginatedFilteredGridContractLines,
  GetPaginatedFilteredGridContractLinesVariables
  >(GetPaginatedFilteredGridContractLinesQuery, {
    client: apolloClientContracts,
    fetchPolicy: 'no-cache',
    onError: (err) =>
      notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger',
      }),
  });

  const getGridContractLines = async (params: PaginatedFilteredGridContractLines) => {
    const response = await _getGridContractLines({
      variables: {
        ...params,
      } as GetPaginatedFilteredGridContractLinesVariables,
    });
    return response.data?.paginatedFilteredGridContractLines;
  };

  return {
    getGridContractLines,
    getGridContractLinesLoading,
  };
}
